module.exports = __webpack_public_path__ + "walking.svg?be82c9ebe3b009792593384d624a0530";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/walking.svg
// module id = 56
// module chunks = 0